import { DatePicker } from 'antd';
import { useTranslation } from 'react-i18next';

import Input from 'components/Input';
import { ENUM_ACTIVE_CHECKBOX } from 'constants/enum';

const DateOption = (props) => {
  const { t } = useTranslation();
  const { data, isPreview } = props;

  return (
    <div>
      {isPreview ? (
        <Input
          value=""
          readOnly
          disabled={true}
          placeholder={t('PLACEHOLDER_DATE')}
          list={[{ text: t('PLACEHOLDER_DATE'), value: '' }]}
          type="dropdown"
          className="w-full"
          classNameInput="rounded-lg w-full text-secondary-354"
        />
      ) : (
        <DatePicker
          disabled={true}
          className={`h-10 datepicker-disabled border-0 !bg-transparent !border-b !border-dashed !border-gray-102/65 !rounded-none text-gray-102/65 !p-0 hover:bg-transparent !hover:outline-none !shadow-none ${isPreview ? 'w-1/2' : '!w-50'}`}
          separator={null}
          placeholder={
            (data?.active_checkbox || [])?.indexOf(ENUM_ACTIVE_CHECKBOX.INCLUDE_YEAR) === -1
              ? t('PLACEHOLDER_DATE_FORMAT')
              : t('PLACEHOLDER_DATE_YEAR_FORMAT')
          }
        />
      )}
    </div>
  );
};

export default DateOption;
